import React, {
  useRef, useEffect, useState,
} from 'react';

import '../Map/Map.scss';

const TestPage = () => {
  const googleMapContainer = useRef();
  const [ map, setMap ] = useState( null );
  const [ poisVisible, setPoisVisible ] = useState( true );
  const [ hybridView, setHybridView ] = useState( false );

  // Load Google Maps API and create map with default center
  useEffect( () => {
    if ( window.google && window.google.maps ) {
      const mapOptions = {
        center: { lat: 39.8283, lng: -98.5795 }, // Geographic center of US
        zoom: 18,
        disableDefaultUI: true,
        clickableIcons: false,
        mapId: 'c439bb9643361fa2fb335fc0',
      };
      const newMap = new window.google.maps.Map(
        googleMapContainer.current,
        mapOptions,
      );
      setMap( newMap );
    }
  }, [] );

  // Setup map types and handle view changes
  useEffect( () => {
    if ( !map || !window.google?.maps ) return;

    const poisOnStyle = [
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [ { visibility: 'on' }, { color: '#ff6b6b' } ],
      },
    ];

    const poisOffStyle = [
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [ { visibility: 'off' } ],
      },
    ];

    map.overlayMapTypes.clear();
    const baseType = hybridView ? 'hybrid' : 'roadmap';
    const styles = poisVisible ? poisOnStyle : poisOffStyle;
    map.setMapTypeId( baseType );
    map.setOptions( { styles } );
  }, [ map, poisVisible, hybridView ] );

  const handleTogglePois = () => {
    setPoisVisible( !poisVisible );
  };

  const handleToggleHybrid = () => {
    setHybridView( !hybridView );
  };

  return (
    <div className="map">
      <div className="mapShell" ref={googleMapContainer} />

      <div
        className="mapControls"
        style={{
          position: 'absolute', bottom: '10px', left: '10px', zIndex: 1000,
        }}
      >
        <button
          type="button"
          onClick={handleTogglePois}
          style={{
            padding: '10px 15px',
            backgroundColor: poisVisible ? '#27ae60' : '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            marginRight: '10px',
          }}
        >
          {poisVisible ? 'Hide POIs' : 'Show POIs'}
        </button>
        <button
          type="button"
          onClick={handleToggleHybrid}
          style={{
            padding: '10px 15px',
            backgroundColor: hybridView ? '#3498db' : '#95a5a6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          }}
        >
          {hybridView ? 'Roadmap' : 'Hybrid'}
        </button>
      </div>
    </div>
  );
};

export default TestPage;
